export default __webpack_public_path__ + "static/media/detail_3.392ef487.jpg";